import {addMilliseconds} from 'date-fns';

import type {CheckoutProfile, CheckoutProfileRule} from '../types';
import {
  checkoutProfileExternalFixture,
  checkoutProfileInternalFixture,
  checkoutProfileVariantsFixture,
  type CheckoutProfileMockVariant,
} from './checkoutProfilesFixtures';

export type CheckoutProfilesMockOptions = {
  profiles?: CheckoutProfile[];
  rules?: CheckoutProfileRule[];
  variants?: CheckoutProfileMockVariant[];
  now?: () => Date;
  baseCurrency?: string;
};

export function createCheckoutProfilesMockState(options: CheckoutProfilesMockOptions = {}) {
  let writes = 0;
  const now = options.now ?? (() => new Date());
  return {
    profiles: new Map(
      (options.profiles ?? [checkoutProfileExternalFixture, checkoutProfileInternalFixture]).map(
        (profile) => [profile.id, structuredClone(profile)]
      )
    ),
    rules: new Map((options.rules ?? []).map((rule) => [rule.id, structuredClone(rule)])),
    variants: structuredClone(options.variants ?? checkoutProfileVariantsFixture),
    baseCurrency: options.baseCurrency ?? 'CZK',
    nextVersion: () => addMilliseconds(now(), writes++).toISOString(),
  };
}

export type CheckoutProfilesMockState = ReturnType<typeof createCheckoutProfilesMockState>;
